var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Labeled } from 'react-admin';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
const ExpansionPanel = withStyles(theme => ({
    root: {
        width: '100%',
        border: 'none',
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
}))(MuiExpansionPanel);
const ExpansionPanelSummary = withStyles(theme => ({
    root: {
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
        padding: 0,
    },
    content: {
        display: 'block',
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
}))(MuiExpansionPanelSummary);
const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(0, 0, 0),
        border: 'none',
    },
}))(MuiExpansionPanelDetails);
export default function CollapsiblePanel(props) {
    const classes = useStyles();
    const contentLabelClasses = useContentStyles();
    const { children, label, labelComponent } = props, rest = __rest(props, ["children", "label", "labelComponent"]);
    return (React.createElement(ExpansionPanel, Object.assign({}, rest),
        React.createElement(ExpansionPanelSummary, { className: classes.expansionPanelSummary, expandIcon: React.createElement(ExpandMoreIcon, { className: classes.expandMoreIconSummary }), "aria-controls": "appoverviewpanel-content" },
            React.createElement(Labeled
            // On <Labeled />, this will translate in a correct `for` attribute on the label
            , { 
                // On <Labeled />, this will translate in a correct `for` attribute on the label
                id: "overview", label: label, classes: contentLabelClasses, className: classes.mainField }),
            labelComponent),
        React.createElement(ExpansionPanelDetails, { className: classes.expansionPanelDetails }, children)));
}
const useStyles = makeStyles(theme => ({
    root: {},
    expandMoreIconSummary: {
        color: theme.palette.primary.main || '#333333',
    },
    expansionPanelSummary: {
        padding: 0,
        '& > div': {
            margin: `${theme.spacing(1)}px 0 !important`,
        },
    },
    expansionPanelDetails: {
        display: 'block',
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(3),
        fontSize: '1rem',
    },
}), {
    name: 'Layer7ApiSelector',
});
const useContentStyles = makeStyles(theme => ({
    label: {
        color: theme.palette.primary.main || '#333333',
        fontFamily: theme.typography.textHub,
        fontWeight: theme.typography.fontWeightBold,
        fontSize: '21px',
        lineHeight: '22px',
        margin: theme.spacing(1, 0, 1, 0),
        transform: 'unset',
    },
}));
//# sourceMappingURL=CollapsiblePanel.js.map